'use client';
var createIdGuard = function(uid, errorMessage) {
    return function(value) {
        if (typeof value !== "string" || value.trim().length === 0) {
            throw new Error(errorMessage);
        }
        return uid + "-" + value;
    };
};

export { createIdGuard };
